import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";

export type RootSliceStateKeys = "";
export interface IRootSliceState extends IRouteReducerSliceStateInit {
  state?: {
    heroTitle: string;
  };
}
const initialState: IRootSliceState = {};

const rootSlice = createSlice({
  name: "root_slice",
  initialState: initialState,
  reducers: {
    /* Cleans Up state with multiple state keys */
    cleanupRoot: (state, action: PayloadAction<{ keys: RootSliceStateKeys[] }>) => {
      for (let i = 0; i < action.payload.keys.length; i++) {
        state[action.payload.keys[i]] = null;
      }
    },
  },
});

export const { cleanupRoot } = rootSlice.actions;

export default rootSlice.reducer;
